angular.module('dpw.services').factory('applicationService',
    ['$q', 'api', 'developerService', 'platformTypes', 'mixpanelService', 'brandService',
        function ($q, api, developerService, platformTypes, mixpanelService, brandService) {
            var sampleApp = null;
            var fetchSampleAppPromise = null;

            function fetchSampleApp() {
                if (sampleApp != null) {
                    return $q.resolve(sampleApp);
                }
                if (fetchSampleAppPromise == null) {
                    fetchSampleAppPromise = api.call(api.myAccount.applications.getSampleApp(), function (data) {
                        sampleApp = data;
                        return data;
                    }, angular.noop);
                }
                return fetchSampleAppPromise;
            }
            
            return {
                fetchSampleApp: fetchSampleApp,
                fetchApps: function (options, paging) {
                    return $q(function (resolve) {
                        api.call(api.myAccount.applications.list(options, paging), function (data) {
                            resolve(data.applications);
                        });
                    });
                },

                fetchApp: function (appId) {
                    var self = this;
                    return $q(function (resolve) {
                        api.call(api.myAccount.applications.get({applicationId: appId}), function (data) {
                            data.application = self.parseApp(data.application);
                            resolve(data);
                        });
                    });
                },

                getAppUsagePlan: function (appId) {
                    return $q(function (resolve) {
                        api.call(api.myAccount.applications.usagePlan.get(appId),
                            function (data) {
                                resolve(data.usagePlan);
                            });
                    });
                },

                getCreator: function (applicationId) {
                    return $q(function (resolve, reject) {
                        api.call(api.admin.developers.application.getCreator({
                            id: applicationId
                        }), function (data) {
                            getAppManipulator(data)
                                .then(function (developer) {
                                    resolve(developer);
                                })
                                .catch(function () {
                                    reject();
                                });
                        }, function () {
                            reject();
                        });
                    });
                },

                getProdApplicant: function (applicationId) {
                    return $q(function (resolve, reject) {
                        api.call(api.admin.developers.application.getLatestProdApplicant({
                            id: applicationId
                        }), function (data) {
                            getAppManipulator(data)
                                .then(function (developer) {
                                    resolve(developer);
                                })
                                .catch(function () {
                                    reject();
                                });
                        }, function () {
                            reject();
                        });
                    });
                },

                isRestApiAppGrantTypeCode: function (application) {
                    var isGrantTypeEqualCode = application.type !== 'ServerOther';
                    return !this.isBotApp(application)
                        && !this.isNotificationApp(application)
                        && !this.isProfileOnly(application)
                        && isGrantTypeEqualCode;
                },

                isPublicApp: function (application) {
                    return application.scope === 'Public';
                },

                isPrivateApp: function (application) {
                    return application.scope === 'Private';
                },

                isActiveApp: function (application) {
                    return application.appState.status === 'Active';
                },

                isBotApp: function (application) {
                    return application.type === 'ServerBot';
                },

                isWebhooksEnabled: function (application) {
                    var webhookPermission = 'SubscriptionWebhook';
                    return _.includes(_.get(application, 'permissions'), webhookPermission) && this.isBotApp(application);
                },

                isNotificationApp: function (application) {
                    return application.type === 'MessagingNotification';
                },

                isProfileOnly: function (application) {
                    return application.type === 'ProfileOnly';
                },

                parseApp: function (application) {
                    application.brands = application.brands || [];
                    return application;
                },

                shouldHideRedirectUri: function (appGrantTypes) {
                    return !_.includes(appGrantTypes, 'AuthorizationCode');
                },

                getAppTypeById: function (id) {
                    return platformTypes.find(function (platformType) {
                        return platformType.id === id;
                    });
                },

                trackApplyForProdEvent: function (options) {
                    options = options || {};
                    var self = this;

                    var orgName = options.orgName;
                    var orgType = options.orgType;
                    var appId = options.appId;
                    var appName = options.appName;
                    var appType = options.appType;
                    var permissions = options.permissions;
                    var shouldRestoreIdentity = options.shouldRestoreIdentity;

                    return self.trackAsAppCreator({
                        appId: appId,
                        shouldRestoreIdentity: shouldRestoreIdentity,
                        trackingExecutor: function (data) {
                            var prodApplicant = data.prodApplicant;
                            var requestBy = (
                                prodApplicant.firstName + ' ' + prodApplicant.lastName + ' (' + prodApplicant.rcExtensionId + ')'
                            );

                            var eventName = mixpanelService.eventNames.APPLY_FOR_PRODUCTION;
                            return mixpanelService.performTracking(eventName, {
                                'Org Type': orgType,
                                'App Name': appName,
                                'App Type': appType,
                                'Permissions': self.formatPermissions(permissions),
                                'Request Date': (new Date()).toISOString(),
                            });
                        }
                    });
                },

                trackGraduateAppEvent: function (options) {
                    options = options || {};
                    var self = this;

                    var appId = options.appId;
                    var appName = options.appName;
                    var appType = options.appType;
                    var orgType = options.orgType;
                    var gradMethod = options.gradMethod;
                    var permissions = options.permissions;
                    var shouldRestoreIdentity = options.shouldRestoreIdentity;

                    return self.trackAsAppCreator({
                        appId: appId,
                        shouldRestoreIdentity: shouldRestoreIdentity,
                        trackingExecutor: function (data) {
                            var appCreator = data.appCreator;
                            var prodApplicant = data.prodApplicant;
                            var remark = '';

                            if (!_.isEmpty(prodApplicant) && prodApplicant.rcExtensionId !== appCreator.rcExtensionId) {
                                remark = prodApplicant.firstName + ' ' + prodApplicant.lastName +
                                    ' (' + prodApplicant.rcExtensionId + ')';
                            }

                            return mixpanelService.performTracking(mixpanelService.eventNames.GRADUATE_APP, {
                                'App Type': appType,
                                'App Name': appName,
                                'Grad Status': 'Grad',
                                'Grad Date': (new Date()).toISOString(),
                                'Grad Method': gradMethod,
                                'Org Type': orgType,
                                'Permissions': self.formatPermissions(permissions),
                                'Remark': remark,
                            });
                        }
                    });
                },

                trackGraduationModeratedEvent: function (options) {
                    options = options || {};
                    var self = this;

                    brandService.fetchBrands().then(function () {
                        var appId = options.appId;
                        var appType = options.appType;
                        var platformTypeId = options.platformTypeId;
                        var appName = options.appName;
                        var permissions = options.permissions;
                        var shortDesc = options.shortDesc;
                        var brandIds = options.brandIds;
                        var reason = 'Suspected SMS Abuse';
                        var shouldRestoreIdentity = options.shouldRestoreIdentity;

                        var platformType = _.get(self.getAppTypeById(platformTypeId), 'text');
                        var brandNames = [];

                        if (Array.isArray(brandIds)) {
                            brandNames = brandIds.map(function (brandId) {
                                return brandService.getBrandMap()[brandId].brandName;
                            });

                            brandNames = _.uniq(brandNames);
                        }

                        return self.trackAsAppCreator({
                            appId: appId,
                            shouldRestoreIdentity: shouldRestoreIdentity,
                            trackingExecutor: function () {
                                return mixpanelService.performTracking(mixpanelService.eventNames.GRADUATION_MODERATED, {
                                    'App Type': appType,
                                    'Platform Type': platformType,
                                    'App Name': appName,
                                    'Permissions': self.formatPermissions(permissions),
                                    'Short Description': shortDesc,
                                    'Carrier Partner': brandNames.join(', '),
                                    'Reason': reason
                                });
                            }
                        });
                    });
                },

                trackGraduationRejectedEvent: function (options) {
                    options = options || {};
                    var self = this;

                    var orgName = options.orgName;
                    var orgType = options.orgType;
                    var appId = options.appId;
                    var appName = options.appName;
                    var appType = options.appType;
                    var requestDate = options.requestDate;
                    var rejectBy = options.rejectBy;
                    var rejectReason = options.rejectReason;
                    var shouldRestoreIdentity = options.shouldRestoreIdentity;

                    return self.trackAsAppCreator({
                        appId: appId,
                        shouldRestoreIdentity: shouldRestoreIdentity,
                        trackingExecutor: function (data) {
                            var prodApplicant = data.prodApplicant;
                            var requestBy = (
                                prodApplicant.firstName + ' ' + prodApplicant.lastName + ' (' + prodApplicant.rcExtensionId + ')'
                            );

                            var eventName = mixpanelService.eventNames.GRADUATION_REJECTED;
                            return mixpanelService.performTracking(eventName, {
                                'Org Type': orgType,
                                'App Name': appName,
                                'App Type': appType,
                                'Request Date': requestDate,
                                'Reject Date': (new Date()).toISOString(),
                                'Reason': rejectReason
                            });
                        }
                    });
                },

                formatPermissions: function (permissions) {
                    return Array.isArray(permissions) ? permissions.join(', ') : '';
                },

                trackAsAppCreator: function (options) {
                    options = options || {};
                    var self = this;

                    var appId = options.appId;
                    var trackingExecutor = options.trackingExecutor || angular.noop;
                    var shouldRestoreIdentity = options.shouldRestoreIdentity;

                    var originalDistinctId = '';
                    var prodApplicant = {};
                    var appCreator = {};

                    return $q.resolve()
                        .then(function () {
                            return mixpanelService.getDistinctId().then(function (distinctId) {
                                originalDistinctId = distinctId;
                            });
                        })
                        .then(function () {
                            return self.getProdApplicant(appId)
                                .then(function (developer) {
                                    prodApplicant = developer;
                                })
                                .catch(function () {
                                    // To ensure the flow will not break
                                });
                        })
                        .then(function () {
                            return self.getCreator(appId)
                                .then(function (developer) {
                                    appCreator = developer;
                                });
                        })
                        .then(function () {
                            mixpanelService.reset();
                            mixpanelService.identify(appCreator);
                        })
                        .then(function () {
                            return trackingExecutor({
                                appCreator: appCreator,
                                prodApplicant: prodApplicant
                            });
                        })
                        .then(function () {
                            mixpanelService.reset();
                        })
                        .then(function () {
                            if (shouldRestoreIdentity) {
                                var developer = {
                                    rcExtensionId: originalDistinctId
                                };

                                mixpanelService.identify(developer);

                                mixpanelService.isUserOptedOut().then(function (isUserOptedOut) {
                                    if (isUserOptedOut) {
                                        mixpanelService.optUserOut(true);
                                    }
                                });
                            }
                        })
                        .catch(function () {
                            // Any errors in this process will not block the whole flow
                        });
                }

            };

            function getAppManipulator(data) {
                var developerId = _.get(data, 'developer.id');

                if (!developerId) {
                    return $q.reject();
                }

                return developerService.getDeveloper(developerId);
            }
        }]);
